import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProvinciasDto } from '../models/provincias.dto';

@Injectable({
  providedIn: 'root'
})
export class ProvinciasService {
  private apiUrl = ``;
  private entity = `provincias`;

  constructor(private http: HttpClient) {

    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
    else
      this.apiUrl = environment.apiUrlDev + this.entity;

  }


  getAll(): Observable<ProvinciasDto[]> {
    return this.http.get<ProvinciasDto[]>(this.apiUrl);
  }

}
